import React from "react";
import {
  CalendarEventType,
  CalendarEventTypeKey,
  EVENT_COLORS,
  EVENT_TYPE_LABELS,
} from "../../utils/calendarUtils";

interface CalendarFiltersProps {
  activeFilters: CalendarEventTypeKey[];
  onFilterChange: (filters: CalendarEventTypeKey[]) => void;
  eventCounts: Record<CalendarEventTypeKey, number>;
}

const ALL_TYPES: CalendarEventTypeKey[] = [
  CalendarEventType.Meeting,
  CalendarEventType.Invoice,
  CalendarEventType.Bill,
  CalendarEventType.Payment,
];

const CalendarFilters: React.FC<CalendarFiltersProps> = ({
  activeFilters,
  onFilterChange,
  eventCounts,
}) => {
  const toggle = (type: CalendarEventTypeKey) => {
    if (activeFilters.includes(type)) {
      onFilterChange(activeFilters.filter((f) => f !== type));
    } else {
      onFilterChange([...activeFilters, type]);
    }
  };

  return (
    <div className="flex flex-wrap gap-2">
      {ALL_TYPES.map((type) => {
        const active = activeFilters.includes(type);
        const colors = EVENT_COLORS[type];
        return (
          <button
            key={type}
            onClick={() => toggle(type)}
            className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-medium transition-all ${
              active
                ? `${colors.bg} ${colors.text} ring-1 ring-inset ring-current`
                : "bg-gray-100 text-gray-400"
            }`}
          >
            <span
              className={`h-2 w-2 rounded-full ${
                active ? colors.dot : "bg-gray-300"
              }`}
            />
            {EVENT_TYPE_LABELS[type]}
            <span
              className={`ml-1 inline-flex items-center justify-center rounded-full px-1.5 text-xs ${
                active
                  ? `${colors.bg} ${colors.text}`
                  : "bg-gray-200 text-gray-400"
              }`}
            >
              {eventCounts[type]}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default CalendarFilters;
